export const isAccessingViaCustomDomain = () => {
  return (
    !window.location.host.includes(window.runtimeEnv?.REACT_APP_HOST_WWW) &&
    window.location.hostname !== 'localhost'
  );
};
